export const STATES = {
  READY: 'READY',
  SUCCESS: 'SUCCESS',
  PROGRESS: 'PROGRESS',
  INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
  ERROR: 'ERROR'
};

export const DELAY_DURATION = {
  SHORT: 1000,
  LONG: 5000
};

export const RECHARGE_PURCHASE_TYPES = {
  ONE_TIME: 'one-time',
  SUBSCRIPTION: 'subscription'
};
